import React from "react";

const SelectArrow = ({ disable = false }) => {
  let fillColor = disable ? "#e0e0e0" : "#666666";
  return (
    <svg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.94974747,1 C2.22588984,1 2.44974747,1.22385763 2.44974747,1.5 L2.44974747,7 L7.94974747,7 C8.22588984,7 8.44974747,7.22385763 8.44974747,7.5 C8.44974747,7.77614237 8.22588984,8 7.94974747,8 L1.94974747,8 C1.67360509,8 1.44974747,7.77614237 1.44974747,7.5 L1.44974747,1.5 C1.44974747,1.22385763 1.67360509,1 1.94974747,1 Z'
        fill={fillColor}
        mask='url(#mask-2)'
        transform='translate(4.949747, 4.500000) rotate(-45.000000) translate(-4.949747, -4.500000) '
      ></path>
    </svg>
  );
};

export default SelectArrow;
